import { render, staticRenderFns } from "./UserListItem.vue?vue&type=template&id=b812d074&scoped=true&"
import script from "./UserListItem.vue?vue&type=script&lang=js&"
export * from "./UserListItem.vue?vue&type=script&lang=js&"
import style0 from "./UserListItem.vue?vue&type=style&index=0&id=b812d074&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b812d074",
  null
  
)

export default component.exports